import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiStoreTemplates } from '../../enums/api-store-templates.enum';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { TemplateConfig } from '../../models/store-templates/template-config';
import { TemplateMenusRQ } from '../../models/store-templates/template-menus-rs';
import { SelectedTemplate } from '../../models/store-templates/template-site';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private http: HttpClient) { }

  getStoreTemplate(siteId: string, templateId: string = "") {
    let url = environment.baseUrl + ApiStoreTemplates.STORE_TEMPLATE + siteId + '/draft';
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    let urlencoded = new HttpParams()
      .set("templateBaseId", templateId);
    return this.http.get(url, { params: urlencoded, headers: headers });
  }

  //update template
  saveDraftTemplate(siteId: string, template: TemplateConfig) {
    let url = environment.baseUrl + ApiStoreTemplates.STORE_TEMPLATE + siteId + '/draft';
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.put(url, JSON.stringify(template), { headers: headers });
  }
  //ADMIN_STORE
  //Get menus
  getTemplateMenus(siteId: string, templateId: string = ""){
    let url = environment.baseUrl + ApiStoreTemplates.ADMIN_STORE + ApiStoreTemplates.MENUS + siteId + '/draft';
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    let urlencoded = new HttpParams()
      .set("templateBaseId", templateId);
    return this.http.get(url, { params: urlencoded, headers: headers });
  }

  saveDraftMenus(siteId: string, templateMenus: TemplateMenusRQ) {
    let url = environment.baseUrl + ApiStoreTemplates.ADMIN_STORE + ApiStoreTemplates.MENUS + siteId + '/draft';
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.put(url, JSON.stringify(templateMenus), { headers: headers });
  }

  publishTemplate(siteId:string, templateAdminId:string){
    let url = environment.baseUrl + ApiStoreTemplates.ADMIN_STORE + siteId +'/' + templateAdminId + ApiStoreTemplates.GO_LIVE;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url,"" ,{ headers: headers });
  }

  publishThemeWeaverTemplate(siteId: string, templateAdminId: string) {
    const url = environment.baseUrl + ApiStoreTemplates.STORE_TEMPLATE
      + siteId + '/draft/theme-weaver/' + templateAdminId + ApiStoreTemplates.GO_LIVE;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url, '', { headers });
  }

  //*--*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
  getTemplateBase(siteId:string){
    let url = environment.baseUrl + ApiStoreTemplates.STORE_UI_TEMPLATE  + siteId + ApiStoreTemplates.STORE_TEMPLATE_BASE;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { headers: headers });
  }

  scrollTo(siteId:string, templateId:string, sectionId:string){
    let url = environment.baseUrl + ApiStoreTemplates.ADMIN_STORE + siteId + ApiStoreTemplates.ADMIN_TEMPLATE + templateId + ApiStoreTemplates.SCROLL_TEMPLATE + sectionId;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url,"" ,{ headers: headers });
  }

  saveThemBasetemplate(siteId:string, templateId:string, themeId:string){
    let url = environment.baseUrl + ApiStoreTemplates.ADMIN_STORE  + siteId + ApiStoreTemplates.STORE_TEMPLATE_BASE +"/"+ templateId + ApiStoreTemplates.THEME + themeId + "/draft";
      let headers = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
      });
      return this.http.patch(url,"",{ headers: headers })
  }

  selectTemplate(selectedTemplate:SelectedTemplate){
    let url = environment.baseUrl + ApiStoreTemplates.STORE_UI_TEMPLATE  +  ApiStoreTemplates.SELECT_TEMPLATE;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });

    return this.http.post(url,selectedTemplate ,{ headers: headers });
  }

  generateAuthCode(siteId: string): Observable<{ code: string; expires_in: number }> {
    let url = environment.baseUrl + 'admin/auth/code';
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post<{ code: string; expires_in: number }>(url, { site_id: siteId }, { headers: headers });
  }
}
